<template>
  <div class="flex w-72 flex-col gap-2 p-2">
    <input
      v-model="searchText"
      type="text"
      :placeholder="$t('W: Søg ikoner...')"
      class="w-full rounded-md border border-border-subtle px-2 py-1.5 text-sm text-text-primary outline-none focus:border-border-strong" />
    <div class="grid grid-cols-8 gap-1 overflow-y-auto" style="max-height: 220px">
      <button
        v-for="iconName in matchingIconNames"
        :key="iconName"
        type="button"
        :title="iconName"
        :class="[
          'flex h-8 w-8 cursor-pointer items-center justify-center rounded-md',
          value === iconName
            ? 'bg-action text-text-on-action'
            : 'text-text-secondary hover:bg-surface-sunken hover:text-text-primary',
        ]"
        @click="select(iconName)">
        <DynamicLucideIcon :name="iconName" class="h-4 w-4" />
      </button>
    </div>
    <p v-if="hasMoreMatches" class="px-1 text-xs text-text-muted">
      {{ $t('W: Der er flere resultater — indsnævr din søgning') }}
    </p>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import lucideIcons from '@iconify-json/lucide/icons.json'

const MAX_RESULTS = 96

export default {
  name: 'IconPickerMenu',

  emits: ['close'],

  props: {
    value: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
    onSelect: {
      type: Function as PropType<(iconName: string) => void>,
      required: true,
    },
  },

  data() {
    return {
      searchText: '',
    }
  },

  computed: {
    allIconNames(): string[] {
      return Object.keys(lucideIcons.icons).sort()
    },

    filteredIconNames(): string[] {
      const search = this.searchText.trim().toLowerCase()
      if (!search) return this.allIconNames
      return this.allIconNames.filter((name) => name.includes(search))
    },

    matchingIconNames(): string[] {
      return this.filteredIconNames.slice(0, MAX_RESULTS)
    },

    hasMoreMatches(): boolean {
      return this.filteredIconNames.length > MAX_RESULTS
    },
  },

  methods: {
    select(iconName: string): void {
      this.onSelect(iconName)
      this.$emit('close')
    },
  },
}
</script>
